const root = document.querySelector('[data-product-inquiry]');
const dialog = root?.querySelector('[data-product-inquiry-dialog]');
const form = root?.querySelector('[data-product-inquiry-form]');
const openButton = root?.querySelector('[data-product-inquiry-open]');
const strings = JSON.parse(document.querySelector('[data-product-inquiry-strings]')?.textContent ?? '{}');

function syncContext() {
  const variant = document.querySelector('[data-variant-id]')?.value;
  const variantField = form?.querySelector('[data-inquiry-variant]');
  const sourceField = form?.querySelector('[data-inquiry-source-url]');
  if (variantField && variant) variantField.value = variant;
  if (sourceField) sourceField.value = window.location.href;
}

function open() {
  if (!dialog) return;
  syncContext();
  dialog.showModal();
  document.documentElement.style.overflow = 'hidden';
  dialog.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
}

function close() {
  if (!dialog?.open) return;
  dialog.close();
  document.documentElement.style.overflow = '';
  openButton?.focus();
}

openButton?.addEventListener('click', open);
root?.querySelector('[data-product-inquiry-close]')?.addEventListener('click', close);
dialog?.addEventListener('click', (event) => { if (event.target === dialog) close(); });
dialog?.addEventListener('cancel', (event) => { event.preventDefault(); close(); });

form?.addEventListener('submit', async (event) => {
  event.preventDefault();
  syncContext();
  const submit = form.querySelector('[type="submit"]');
  const status = form.querySelector('[data-product-inquiry-status]');
  const data = new FormData(form);
  const payload = Object.fromEntries(data.entries());
  payload.privacyAcknowledged = data.get('privacyAcknowledged') === 'on';
  payload.marketingConsent = data.get('marketingConsent') === 'on';
  submit.disabled = true;
  status.textContent = strings.sending;
  status.dataset.state = '';
  try {
    const response = await fetch(form.action, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
    if (!response.ok) throw new Error('request_failed');
    form.reset();
    syncContext();
    status.textContent = strings.success;
    status.dataset.state = 'success';
  } catch {
    status.textContent = strings.error;
    status.dataset.state = 'error';
  } finally { submit.disabled = false; }
});
